import { render, staticRenderFns } from "./index3-single.vue?vue&type=template&id=6415941f&scoped=true&"
import script from "./index3-single.vue?vue&type=script&lang=js&"
export * from "./index3-single.vue?vue&type=script&lang=js&"
import style0 from "./index3-single.vue?vue&type=style&index=0&id=6415941f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6415941f",
  null
  
)

export default component.exports